// extracted by mini-css-extract-plugin
module.exports = {"answer":"AnswerBox_answer__fkxj1"};